import React from "react";

export const HeaterCoolerIcon = () => {
  return (
    <svg
      width="36"
      height="37"
      viewBox="0 0 36 37"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M35.9167 16.7083H28.4455L34.2505 10.9033L31.7242 8.35915L23.375 16.7083H19.7917V13.125L28.1409 4.77581L25.5967 2.24956L19.7917 8.05456V0.583313H16.2084V8.05456L10.4034 2.24956L7.85921 4.77581L16.2084 13.125V16.7083H12.625L4.27587 8.35915L1.74962 10.9033L7.55462 16.7083H0.083374V20.2916H7.55462L1.74962 26.0966L4.27587 28.6408L12.625 20.2916H16.2084V23.875L7.85921 32.2241L10.4034 34.7504L16.2084 28.9454V36.4166H19.7917V28.9454L25.5967 34.7504L28.1409 32.2241L19.7917 23.875V20.2916H23.375L31.7242 28.6408L34.2505 26.0966L28.4455 20.2916H35.9167V16.7083Z" />
    </svg>
  );
};
